export default function EFCycle(props: any) {
    return (
        <svg width="122" height="59" viewBox="0 0 122 59" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M15.013 15.1523C14.8648 15.7433 14.2345 15.7038 13.7362 15.9044C11.7613 16.6994 10.17 18.3122 8.77435 19.867C4.80115 24.2935 2.93681 29.7664 5.55348 35.4574C7.31099 39.2797 10.827 41.8792 14.2875 44.0769C23.0358 49.6327 32.9006 52.3828 43.1012 53.8534C57.379 55.9116 72.3361 56.6883 86.7135 55.2996C95.5765 54.4435 105.153 52.6953 112.916 48.0685C119.503 44.142 120.567 37.4665 116.949 30.9741C109.631 17.8429 95.8064 10.2081 81.5485 6.96669C62.6503 2.67026 40.7772 1.4522 21.6868 5.37584C15.4116 6.66558 8.19696 8.6638 3 12.5491"
                stroke="#11A154"
                strokeWidth="5"
                strokeLinecap="round"
            />
        </svg>
    );
}
